import {Injectable} from '@angular/core';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { ToastMessageType } from './ToastMessageType';
import { Message, SimpleMessage } from './Message';
import { ToastButtons } from './ToastButtons';
import { ToastResponse } from './ToastResponses';

@Injectable({
    providedIn: 'root'
})
export class ToastService {
  private messages : Message[] = [];
  
  private bMessagesSubject = new BehaviorSubject<Message[]>([]);
  
  constructor() {
      this.bMessagesSubject.next(this.messages);
  }
  
  dismissMessage(itemKey: string, response: ToastResponse = null) {
    let message = this.getMessage(itemKey);
    if(response!==ToastResponse.TimeOut) {
        clearTimeout(message.getTimeoutReference());
    }
    message.complete(response);
    this.removeMessage(message);
  }
  
  relayMessage(itemKey: string, response: ToastResponse) {
      let message = this.getMessage(itemKey);
      clearTimeout(message.getTimeoutReference());
      if(message.async) {
          message.async.subscribe({
              next: (msg: SimpleMessage) => {
                  message = Object.assign(message, msg);
              },
              complete: () => {
                  timer(200).subscribe(() => {
                      message.close();
                      this.removeMessage(message);    
                  });
              }
          });
          message.sendResponse(response);
          timer(200).subscribe(() => message.showLoader = true);
          message.buttons = null;
      } else {
          message.complete(response);
          this.removeMessage(message);
      }
  }
  
  sendMessage(title: string, content: string, style: ToastMessageType, buttons: ToastButtons = ToastButtons.None, timeout: number = 3500, async: Observable<any> = null) {
      const message = new Message(title, content, style, buttons, async);
      this.messages = [...this.messages.slice(), message];
      this.bMessagesSubject.next(this.messages);
      if(timeout>0){
          message.setTimeoutReference(setTimeout(()=>{
              this.dismissMessage(message.uniqueId, ToastResponse.TimeOut);
          }, timeout));
      }
      return message.getObservable();
  }
  
  getMessages() : Observable<Message[]> {
    return this.bMessagesSubject.asObservable();
  }
  
  private removeMessage(message: Message) {
      this.messages = this.messages.filter(x=>x.uniqueId!==message.uniqueId);
      this.bMessagesSubject.next(this.messages);
  }
  
  private getMessage(key: string) : Message {
      return this.messages
        .filter(x=>x.uniqueId===key).pop();
  }
}
